import React from 'react';

function nextArrow(color) {
  const stroke = color ? color : '#FFFFFF';
  return (
    <div>
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 29.3 63.6" style={{enableBackground: 'new 0 0 29.3 63.6'}} xmlSpace="preserve">
        <title>designcue_slider_arrow_right</title>
        <polyline
          style={{ fill: 'none', stroke, strokeWidth:3, strokeLinecap: 'round', strokeLinejoin: 'round' }}
          points="7.4,49.2 21.9,31.8 7.4,14.3 "
        />
      </svg>
    </div>
  );
}

function prevArrow(color) {
  const stroke = color ? color : '#FFFFFF';
  return (
    <div>
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 29.3 63.6" style={{enableBackground: 'new 0 0 29.3 63.6'}} xmlSpace="preserve">
        <title>designcue_slider_arrow_right</title>
        <polyline
          style={{ fill: 'none', stroke, strokeWidth:3, strokeLinecap: 'round', strokeLinejoin: 'round' }}
          points="21.9,14.3 7.4,31.8 21.9,49.2"
        />
      </svg>
    </div>
  );
}

function RightArrow() {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 29.3 63.6" style={{enableBackground: 'new 0 0 29.3 63.6'}} xmlSpace="preserve">
      <title>designcue_slider_arrow_right</title>
      <polyline
        style={{ fill: 'none', stroke: '#FFFFFF', strokeWidth:3, strokeLinecap: 'round', strokeLinejoin: 'round' }}
        points="7.4,49.2 21.9,31.8 7.4,14.3 "
      />
    </svg>
  );
}

function LeftArrow() {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 29.3 63.6" style={{enableBackground: 'new 0 0 29.3 63.6'}} xmlSpace="preserve">
      <title>designcue_slider_arrow_right</title>
      <polyline
        style={{ fill: 'none', stroke: '#FFFFFF', strokeWidth:3, strokeLinecap: 'round', strokeLinejoin: 'round' }}
        points="21.9,14.3 7.4,31.8 21.9,49.2"
      />
    </svg>
  );
}

function UpArrow() {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 49 30" style={{enableBackground: 'new 0 0 49 30'}} xmlSpace="preserve">
      <title>designcue_slider_arrow_right</title>
      <polyline
        style={{ fill: 'none', stroke: '#FFFFFF', strokeWidth:3, strokeLinecap: 'round', strokeLinejoin: 'round' }}
        points="42.1,22 24.6,7.6 7.2,22 "
      />
    </svg>
  );
}

function DownArrow() {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 49 30" style={{enableBackground: 'new 0 0 49 30'}} xmlSpace="preserve">
      <title>designcue_slider_arrow_right</title>
      <polyline
        style={{ fill: 'none', stroke: '#FFFFFF', strokeWidth:3, strokeLinecap: 'round', strokeLinejoin: 'round' }}
        points="7.2,7.6 24.6,22 42.1,7.6 "
      />
    </svg>
  );
}

export {
  nextArrow,
  prevArrow,
  UpArrow,
  DownArrow,
  RightArrow,
  LeftArrow
};



// WEBPACK FOOTER //
// ./src/components/Arrows/index.js